import { InjectionToken } from '@angular/core';
import { AuthConfig } from '@auth0/auth0-angular/lib/auth.config';

export const EnvironmentInstanceToken = new InjectionToken<PaceEnvironment>('PaceEnvironment');

export interface PaceEnvironment {
    production: boolean;
    appId: string;
    serviceHost: string;
    servicePath: string;
    serviceProtocol: string;
    operateInMockMode: boolean;
    reportIssueSupportEmail: string;
    reportIssueUrl: string;
    reportIssueClientId?: string;
    reportIssueClientSecret?: string;
    bundleIdentifierName: string;
    platform: PACE_PLATFORM;
    sapClient?: string;
    subscribeNotificationsUrl?: string;
    loginUrl?: string;
    subscriptionServerPublicKey?: string;
    complaintsLinkUrl?: string;
    clientId?: string;
    authority?: string;
    useMsal?: boolean;
    auth0?: AuthConfig;
    fxAppScope?: string;
    btpApimScope?: string;
    graphApiUrl?: string;
}

export enum PACE_PLATFORM {
    WINDOWS = 'windows',
    IOS = 'iOS',
    BROWSER = 'browser',
    ELECTRON = 'electron',
}
